import React, { useEffect, lazy } from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { initialized } from 'modules/gtm/selectors';
import { roles } from 'utility/constants/roles';

const Marketplace = lazy(() => import('containers/pages/shop/Marketplace'));

const AddProduct = lazy(() => import('containers/pages/shop/AddProduct'));

const BasketItemWizard = lazy(
	() => import('containers/pages/shop/BasketItemWizard'),
);

const DomainSearch = lazy(
	() => import('containers/pages/domains/Register/Search'),
);

const DomainConfigure = lazy(
	() => import('containers/pages/domains/Register/Configure'),
);

const PaymentMethod = lazy(
	() => import('containers/pages/shop/Cart/PaymentMethod'),
);

const Checkout = lazy(() => import('containers/pages/shop/Cart/Checkout'));

const ConfigPackage = lazy(() => import('containers/pages/shop/ConfigPackage'));
const SpecialOffers = lazy(() => import('containers/pages/shop/SpecialOffers'));

const NotFound = lazy(() => import('pages/error/NotFound'));

const ShopRouter = () => {
	const location = useLocation();
	const history = useHistory();
	const gtmInitialized = useSelector(initialized);
	useEffect(() => {
		// can't do navigation events until GTM has been initialized
		if (gtmInitialized && location.pathname === '/shop') {
			history.replace('/shop/marketplace');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, gtmInitialized]);

	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/shop/marketplace/:tab"
				component={Marketplace}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/marketplace"
				component={Marketplace}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/domain"
				component={DomainSearch}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/domain/configure"
				component={DomainConfigure}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<Route exact path="/shop/add/:productCode" component={AddProduct} />
			<Route
				exact
				path="/shop/config/:productKey/:step"
				component={BasketItemWizard}
			/>
			<Route
				exact
				path="/shop/config/:productKey"
				component={BasketItemWizard}
			/>
			<Route
				exact
				path="/shop/package/:packageCode"
				component={ConfigPackage}
			/>
			<Route
				exact
				path="/shop/package/:packageCode/:uuid"
				component={ConfigPackage}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/payment-method"
				component={PaymentMethod}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/checkout"
				component={Checkout}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/special-offers"
				component={SpecialOffers}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default ShopRouter;
